const API_PORT = '6545';

function getProtocol() {
  return window.location.protocol === 'https:' ? 'https:' : 'http:';
}

function getWsProtocol() {
  return window.location.protocol === 'https:' ? 'wss:' : 'ws:';
}

function getHostname() {
  return window.location.hostname || 'localhost';
}

export function getApiBaseUrl() {
  // Produção: URL definida em frontend/.env.production (baked no build)
  if (process.env.VUE_APP_API_BASE_URL) {
    return `${process.env.VUE_APP_API_BASE_URL}/api`;
  }
  // Dev local: porta direta
  return `${getProtocol()}//${getHostname()}:${API_PORT}/api`;
}

export function getApiV1BaseUrl() {
  return `${getApiBaseUrl()}/v1`;
}

export function getWsUrl() {
  if (process.env.VUE_APP_WS_URL) {
    return process.env.VUE_APP_WS_URL;
  }
  return `${getWsProtocol()}//${getHostname()}:${API_PORT}`;
}
